var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 1440,
    height: 560,
    preserveAspectRatio: "none",
    viewBox: "0 0 1440 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#SvgjsMask1070\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 560,
    x: 0,
    y: 0,
    fill: "url(#SvgjsLinearGradient1071)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.30705708353645 338.81985225086777L400.54888620657215 438.3130274938093 500.04206144951365 454.0711983707736 515.800232326478 354.57802312783207z",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.8065195014768 525.9166602808808L812.4575715326185 427.03468309102055 713.5755943427583 418.3836310598788 704.9245423116165 517.2656082497391z",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.94 155.91 a106.88 106.88 0 1 0 213.76 0 a106.88 106.88 0 1 0 -213.76 0z",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.5969491695334 341.679982233934L727.1753042358338 244.05669464620644 629.5520166481062 352.4783395799061 737.9736615818059 450.10162716763364z",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.7709565786464 198.6981602117529L699.6132922034379 106.69922852432542 607.6143605160105 17.856892899533875 518.772024891219 109.85582458696135z",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28 322.26 a117.85 117.85 0 1 0 235.7 0 a117.85 117.85 0 1 0 -235.7 0z",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.0781093256804 256.52014801916636L691.2691809007468 296.6311813126433 719.3401950534292 180.28905730330519z",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.253,643.759C1233.771,644.308,1273.019,599.659,1299.59,553.2C1325.923,507.157,1341.521,452.41,1316.408,405.691C1290.155,356.85,1235.702,330.778,1180.253,331.186C1125.525,331.589,1072.942,359.201,1047.523,407.669C1023.596,453.293,1039.832,505.888,1065.079,550.796C1090.993,596.89,1127.377,643.217,1180.253,643.759",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.013,338.182C916.978,336.984,956.417,309.395,977.707,269.771C997.885,232.216,992.52,188.355,972.832,150.54C951.205,109,918.845,66.979,872.013,66.761C824.943,66.542,792.392,108.434,769.554,149.594C747.575,189.205,734.468,235.869,756.094,275.674C778.556,317.017,824.979,339.435,872.013,338.182",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-94.42 483.32 a98.47 98.47 0 1 0 196.94 0 a98.47 98.47 0 1 0 -196.94 0z",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.928919948747 130.66549473599383L1087.4861541665198 41.93852226915983 998.7591816996858 97.38128805138713 1054.201947481913 186.10826051822113z",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.6,558.971C213.777,558.861,237.711,548.784,251.892,527.98C268.262,503.965,278.459,473.11,264.506,447.614C250.149,421.38,218.47,410.864,188.6,412.325C161.243,413.663,137.804,430.489,124.55,454.459C111.743,477.62,110.51,505.973,124.339,528.539C137.612,550.197,163.198,559.082,188.6,558.971",
    fill: "rgba(2, 103, 0, 1)",
    className: "triangle-float1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask1070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 560,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.28%",
    y1: "-39.29%",
    x2: "84.72%",
    y2: "139.29%",
    gradientUnits: "userSpaceOnUse",
    id: "SvgjsLinearGradient1071"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(2, 82, 0, 1)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(2, 66, 0, 1)",
    offset: 1
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            @keyframes float1 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(-10px, 0)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float1 {\r\n                animation: float1 5s infinite;\r\n            }\r\n\r\n            @keyframes float2 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(-5px, -5px)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float2 {\r\n                animation: float2 4s infinite;\r\n            }\r\n\r\n            @keyframes float3 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(0, -10px)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float3 {\r\n                animation: float3 6s infinite;\r\n            }\r\n        "))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.85c56b368a4d28ba3286b9eb3437b011.svg";
export { ForwardRef as ReactComponent };